import { css } from "styled-components";
import { RenderModalSize } from "../constants";
import { RenderModalSizeType } from "..";

export const getRenderModalSize = (renderModalSize: RenderModalSizeType) => {
  return {
    [RenderModalSize.Small]: css`
      min-width: 340px;
      min-height: 220px;
    `,
    [RenderModalSize.Middle]: css`
      min-width: 480px;
      min-height: 300px;
    `,
    [RenderModalSize.Large]: css`
      min-width: 600px;
      min-height: 400px;
    `,
    [RenderModalSize.Giant]: css`
      min-width: 680px;
      min-height: 480px;
    `,
  }[renderModalSize];
};
